
const Joi = require("joi");
const ValidationTranslateFile = require("../../src/config/ValidationTranslateFile.jsx");
const currentLang = ValidationTranslateFile()

const writeMessageSchema = (data) => {
  const schema = Joi.object({
    inmatesId: Joi.number().min(1).required().messages({
      "number.base": currentLang?.ValidationSchema?.Please_Choose_Inmate,
      "number.min": currentLang?.ValidationSchema?.Please_Choose_Inmate,
      "any.only": currentLang?.ValidationSchema?.Please_Choose_Inmate,
      "any.required": currentLang?.ValidationSchema?.Please_Choose_Inmate,
      "string.empty": currentLang?.ValidationSchema?.Please_Choose_Inmate,
    }),

    subject: Joi.string().trim().required().messages({
      "any.required": currentLang?.ValidationSchema?.Please_enter_subject,
      "string.empty": currentLang?.ValidationSchema?.Please_enter_subject,
    }),

    messageBody: Joi.string().trim().required().messages({
      "any.required": currentLang?.ValidationSchema?.Please_enter_description,
      "string.empty": currentLang?.ValidationSchema?.Please_enter_description,
    }),
  }).unknown(true); // Allow unknown keys in the object (useful if you're validating only part of the data)

  return schema.validate(data, { abortEarly: false });
};

module.exports = writeMessageSchema;
